const privacyPage = (WpTag) => `
  content
  subtitle
  title
`;

module.exports.privacyPage = privacyPage;
